import {useEffect,useRef} from 'react'
import Grid from '@mui/material/Grid'
import { useTranslation } from 'react-multi-lang'

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import { useReactToPrint } from 'react-to-print'
import PrintTemplate from './print_template'
import { useCookies } from 'react-cookie'

import { deliveryorderpage, iBillDetails, Iprintdeliverynote } from '../../services/api/api'
import { Units } from './common'
import { getCurrentDate } from '../../services/current_time'

interface iProps {data?:Iprintdeliverynote,close:Function}

export const PrintDeliveryOrder=({data,close}:iProps)=>{
const t=useTranslation()
const componenetRef=useRef(null)
const [cookie] = useCookies();

//const [pages,setPages]=useState<any[]>([])
const handlePrint=useReactToPrint({
    contentRef:componenetRef,
    onAfterPrint:()=>close(),
    documentTitle:'اذن التحميل'
})

useEffect(()=>{
if(data)handlePrint()

},[data])

 

const handleRow=(ele:deliveryorderpage , index=0)=>{
if (!ele) return (<></>)
    let description = ele.description?.split('/')
    let material_only = description && description.length>1 ? description[0]: ''
return (
    <TableRow key={index}>
    <TableCell style={{border:'1px solid #a7a4a4'}}
    className=' less_spaces'>
        {index+1}
     </TableCell>
     <TableCell style={{border:'1px solid #a7a4a4'}}
    className=' less_spaces'>
        {ele.piece_code}
     </TableCell>
   
     <TableCell style={{border:'1px solid #a7a4a4',textAlign:'left',paddingLeft:'5px'}}
     className='less_spaces'>
         {ele.description}
     </TableCell>
     <TableCell style={{border:'1px solid #a7a4a4'}}
     className=' less_spaces'>
      {ele.piece_count}
     </TableCell>
     <TableCell style={{border:'1px solid #a7a4a4'}}
      className=' less_spaces'>
        {ele.unit =='Piece'? ele.area:
        ((ele.piece_count??0) * (ele.area??0)).toFixed(2)}
     </TableCell>
  
     <TableCell style={{border:'1px solid #a7a4a4' ,textAlign:'left',paddingLeft:'5px'}}
      className='less_spaces'>
     {ele.measures + '('+Units[ele.unit??'Area']+')'}
     </TableCell>
    
   
     
     
 </TableRow>
)
}
const upperPart =(data:Iprintdeliverynote)=>{
    return (
        <Grid  container  size={12} marginY={2}  >
        <Grid  size={6} display="flex" justifyContent={"flex-end"}
        alignItems={'center'} className='fs-12'>
        
        {/* <input id="order_no" value={data.order_no}
     style={{direction:'rtl',fontWeight:''}} className='bottom-border'>
        </input> */}
        <div className='' >
        { "Q"+data.order_num }
        </div>
        <div className='label text-right'>
            {t("order_no")}
        </div>
        </Grid>
        <Grid  size={6} display="flex" justifyContent={"flex-end"}
        alignItems={'center'} className='fs-12'>
        
        {/* <input id="order_no" value={data.order_no}
     style={{direction:'rtl',fontWeight:''}} className='bottom-border'>
        </input> */}
        <div className='' >
        { "R"+data.bill_number }
        </div>
        <div className='label text-right'>
            رقم عرض السعر
        </div>
        </Grid>
        <Grid  size={6} display="flex" justifyContent={"flex-end"}
        alignItems={'center'}
        className='fs-12'>
  
        {/* <input id="delivery_date" value={data.date}
            style={{direction:'rtl',fontWeight:''}}  className='bottom-border'>
        </input> */}
        <div className=''>{data.delivery_order_date?.replaceAll('-','/')}</div>
        <div  className="label">{t("delivery_date")}</div>
        </Grid>
        <Grid  size={6} display="flex" justifyContent={"flex-end"}
        alignItems={'center'}
        className='fs-12'>
  
        {/* <input id="delivery_date" value={data.date}
            style={{direction:'rtl',fontWeight:''}}  className='bottom-border'>
        </input> */}
        <div className=''>{getCurrentDate(0)?.replaceAll('-','/')}</div>
        <div  className="label">تاريخ امر التحميل</div>
        </Grid>
        <Grid  container size={12} alignItems={'center'} 
                            justifyContent={'flex-end'} paddingX={0}className='fs-12' >
                             
                                {/* <input value={data.client_name}  
                                style={{flex:1,margin:'0 5px',direction:'rtl',fontWeight:''}}
                                className='bottom-border'
                                /> */}
                                <div className=''>
                                {data.client}
                                </div>
                                <div className="label" >
                                    {t("gentlemen")}
                                </div>
                            </Grid>
    </Grid>
    )
}
const lowerPart =(data:any)=>{
    return (
        <Grid  container size={12}  rowGap={1}
        >
                 <Grid  size={12} container justifyContent={'flex-end'} alignItems={'flex-start'}
                 className='fs-12' >

                     {/* <input value={data.seller_name}  
                      className='bottom-border'
                     style={{flex:1,margin:'0 5px',direction:'rtl',fontWeight:''}}/>
                      */}
                     <div className=''>
                   {data.total_piece_count}  
                     </div>
                    <div className="label text-right" >
                         عدد القطع الكلي
                     </div>
                 </Grid>
                  <Grid  size={12} container justifyContent={'flex-end'} alignItems={'center'}
                 className='fs-12' >

                     {/* <input value={data.seller_name}  
                      className='bottom-border'
                     style={{flex:1,margin:'0 5px',direction:'rtl',fontWeight:''}}/>
                      */}
                     <div className=''>
                   {cookie?.company_info?.name}  
                     </div>
                    <div className="label text-right" >
                         {t("seller")}
                     </div>
                 </Grid>
                 <Grid size={12} container justifyContent={"flex-end"} 
                 alignItems={'center'} className='fs-12'>
                   
                     {/* <textarea rows={3} value={data.note} 
                      className='bottom-border'
                      style={{flex:1,margin:'0 5px',direction:'rtl',fontWeight:''}}/> */}
                      <div className=''>
                      {data.note} 
                      </div>
                     <div className="label text-right" >
                         {t("nots")}
                     </div>
                 </Grid>
        </Grid>
    )
}

//console.log('data',data)

    return (
        <div
        ref={componenetRef as any}
        className="printMe"
        style={{minHeight:'100vh'}}
      >
         <PrintTemplate
         
          title_ar=' اذن التحميل'
          title_en='  Delivery Notice'
         

          >
        {
            data && data.pages.length>0 && data.pages[0].page.length>0?
       
         

            <Grid container  rowGap={1} paddingTop={0} marginTop={0}  display="flex"
             flexDirection="column" justifyContent="flex-start">
               
                 {
                 
                  upperPart(data)
                 }
             
                  
            
                <Grid  container  size={12} rowGap={1} 
                
                display="flex" alignItems="flex-start" 
                flexDirection='column' justifyContent="flex-start" >                         
                    <Grid size={12} marginY={1}>
                        <Table>
                            <TableHead>
                                <TableRow >
                                        <TableCell style={{border:"1px dashed black"}}>
                                            <span>مسلسل</span>
                                     
                                        </TableCell>
                                        <TableCell style={{border:"1px dashed black"}}>
                                            <span>رمز القطعة</span>
                                     
                                        </TableCell>
                                       
                                        <TableCell style={{border:"1px dashed black"}}>
                                            <div style={{display:'flex',height:'100%',width:'100%',justifyContent:'space-between'}}>

                                            <span style={{padding:'10px'}}>البيان</span> 
                                            
                                            </div>
                                            
                                        </TableCell>
                                         <TableCell style={{
                                            border:"1px dashed black"}}>
                                                    <div style={{display:'flex',height:'100%',width:'100%',justifyContent:'space-between'}}>
                                            <div style={{padding:'10px'}}>العدد</div> 
                                        
                                            </div>
                                            
                                        </TableCell>
                                       
                                        <TableCell style={{border:"1px dashed black"}}>
                                            <span>الكمية</span>
                                         
                                        </TableCell>
                                       
                                        <TableCell style={{border:"1px dashed black"}}>
                                            <span>المقاسات</span>
                                          
                                        </TableCell>
                                        

                  
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                       
                                       
                                          {
                                            data?.pages[0].page.map((page:deliveryorderpage,page_index:number)=>    
                                            handleRow(page,page_index))
                                          }
                            </TableBody>
                        </Table>
                    </Grid>
                        {
                   
                            lowerPart(data)
                        }
                        </Grid>
                    

         
            </Grid>
        
        :null
    }
          </PrintTemplate>
          </div> 
      
    )
}